import { ModuleLayout } from '@billy/design-system'
import { PropsWithChildren, ReactElement, ReactNode, useMemo } from 'react'
import { useLocalStorage } from 'react-use'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { E_INVOICING_STEP_TO_PATH } from '../../../../constants/eInvoicingStepPathMapping'
import { E_INVOICING_ENTRY_URL } from '../../../../constants/filters'
import { useEInvoicingSetup } from '../../../../hooks/useEInvoicingSetup'
import { getEInvoicesUrl } from '../../../../utils'
import * as Styled from './styles'

interface EInvoicingStepContainerProps {
  headerContent?: ReactNode
}

export const EInvoicingStepContainer = ({
  children,
  headerContent,
}: PropsWithChildren<EInvoicingStepContainerProps>): ReactElement => {
  const { organization } = useUserOrganization()
  const { currentStep, stepHistory } = useEInvoicingSetup()
  const [entryUrl] = useLocalStorage<string>(E_INVOICING_ENTRY_URL)

  const previousPath = useMemo(() => {
    if (currentStep === 'EMPTY_STATE') {
      // Navigate back to the uploads page
      return entryUrl ?? getEInvoicesUrl(organization)
    }
    const previousStep = stepHistory[stepHistory.length - 2] || 'EMPTY_STATE'
    return E_INVOICING_STEP_TO_PATH[previousStep]
  }, [entryUrl, currentStep, organization, stepHistory])
  return (
    <ModuleLayout title=" " withBackButton backButtonTo={previousPath} fullHeight headerContent={headerContent}>
      <Styled.StepContainer>{children}</Styled.StepContainer>
    </ModuleLayout>
  )
}
